module.exports = __webpack_public_path__ + "static/media/21_4.c34b8e68.png";